import React from "react";

import { Panel } from "../../../components/panels/index";
import ICalendarFeedPanel from "./ICalendarFeedsPanel";
import PanelSegmentType from "components/panels/PanelSegment/PanelSegment";

declare const viewModel: server.viewmodel.PersonalSettingsModifyFrontModel;

export default class App extends React.Component {
  componentDidMount() {
    document.title = RESX.Feed.iCalendarFeeds;
  }

  public render(): JSX.Element {
    return (
      <>
        <PanelSegmentType>
          <PanelSegmentType.Header size="h1header">
            <PanelSegmentType.Title title={RESX.Feed.iCalendarFeeds} />
            <PanelSegmentType.SupportQuestionMark articleId={serverReference.supportArticleIds.iCalendarFeeds} />
          </PanelSegmentType.Header>
        </PanelSegmentType>

        <Panel
          panelClassName="s1_listview-panel"
        >
          <ICalendarFeedPanel
            items={viewModel.iCalendarFeeds}
          />
        </Panel>
      </>
    );
  }
}
